// extracted by mini-css-extract-plugin
export default {"container":"TitledLogo_container__Z76Y+","title":"TitledLogo_title__Q-IPw"};